// extracted by mini-css-extract-plugin
export default {"modalWrapper":"sghMhtb2Fbw72XIWTXR_"};